const user_identity_details = {
    social_identity_page_title: 'جزئیات هویت اجتماعی',
    back_to_user_details: 'بازگشت به جزئیات کاربر',
    delete_identity: 'حذف اتصال هویت',
    social_account: {
        title: 'حساب اجتماعی',
        description: 'داده‌های کاربر و اطلاعات پروفایل همگام‌شده از حساب {{connectorName}} متصل را مشاهده کنید.',
        provider_name: 'نام ارائه‌دهنده هویت اجتماعی',
        identity_id: 'شناسه هویت اجتماعی',
        user_profile: 'پروفایل کاربر همگام‌شده از ارائه‌دهنده هویت اجتماعی',
    },
    sso_account: {
        title: 'حساب SSO سازمانی',
        description: 'داده‌های کاربر و اطلاعات پروفایل همگام‌شده از حساب {{connectorName}} متصل را مشاهده کنید.',
        provider_name: 'نام ارائه‌دهنده هویت SSO سازمانی',
        identity_id: 'شناسه هویت SSO سازمانی',
        user_profile: 'پروفایل کاربر همگام‌شده از ارائه‌دهنده هویت SSO سازمانی',
    },
    token_storage: {
        title: 'توکن دسترسی',
        description: 'توکن‌های دسترسی و تازه‌سازی از {{connectorName}} را در Secret Vault ذخیره کنید. فراخوانی‌های خودکار API بدون رضایت مکرر کاربر را ممکن می‌سازد.',
    },
    access_token: {
        title: 'توکن دسترسی',
        description_active: 'توکن دسترسی فعال است و به‌صورت امن در Secret Vault ذخیره شده است. محصول شما می‌تواند از آن برای دسترسی به APIهای {{connectorName}} استفاده کند.',
        description_inactive: 'این توکن دسترسی غیرفعال است (مثلاً لغو شده). کاربران باید دسترسی را دوباره مجاز کنند تا عملکرد بازیابی شود.',
        description_expired: 'این توکن دسترسی منقضی شده است. تازه‌سازی در درخواست API بعدی با توکن تازه‌سازی به‌صورت خودکار انجام می‌شود. اگر توکن تازه‌سازی در دسترس نباشد، احراز هویت مجدد کاربر لازم است.',
    },
    refresh_token: {
        available: 'توکن تازه‌سازی در دسترس است. اگر توکن دسترسی منقضی شود، با توکن تازه‌سازی به‌صورت خودکار تازه می‌شود.',
        not_available: 'توکن تازه‌سازی در دسترس نیست. پس از انقضای توکن دسترسی، کاربران باید دوباره احراز هویت کنند تا توکن‌های جدید دریافت کنند.',
    },
    token_status: 'وضعیت توکن',
    created_at: 'ایجاد شده در',
    updated_at: 'به‌روزرسانی شده در',
    expires_at: 'انقضا در',
    scopes: 'Scopeها',
    delete_tokens: {
        title: 'حذف توکن‌ها',
        description: 'توکن‌های ذخیره‌شده را حذف کنید. کاربران باید دسترسی را دوباره مجاز کنند تا عملکرد بازیابی شود.',
        confirmation_message: 'آیا مطمئن هستید که می‌خواهید توکن‌ها را حذف کنید؟ Logto Secret Vault توکن‌های دسترسی و تازه‌سازی {{connectorName}} ذخیره‌شده را حذف می‌کند. این کاربر باید دوباره مجاز کند تا دسترسی API {{connectorName}} بازیابی شود.',
    },
    token_storage_disabled: {
        title: 'ذخیره توکن برای این اتصال‌دهنده غیرفعال است',
        description: 'کاربران فعلاً فقط می‌توانند از {{connectorName}} برای ورود، اتصال حساب‌ها یا همگام‌سازی پروفایل در هر جریان رضایت استفاده کنند. برای دسترسی به APIهای {{connectorName}} و انجام اقدامات از طرف کاربران، لطفاً ذخیره توکن را فعال کنید در',
    },
};
export default user_identity_details;
